(function () {
  window.clickOff = function ($el, callback) {
    if (!$el) return false;
    $(document).on('click', function (e) {
      if ($el.has(e.target).length === 0 && !$el.is(e.target)) {
        callback($el);
      }
    });
  };
})();

function closeHeaderMenu() {
  $('.b-h__menu').addClass('b-h__menu_hide');
  $('.b-burger').removeClass('b-burger_active');
  setTimeout(() => {
    $('.b-h__menu').removeClass('b-h__menu_hide');
    $('body').removeClass('_overflow');
    $('.b-h').css({'z-index': '15'}).removeClass('b-h_opened');
    $('.b-h__menu').removeClass('b-h__menu_opened');
  }, 250);
}

$(function () {
  /* open menu */
  $('[data-toggle="menu"]').on('click', function () {
    if ($('.b-h__menu').hasClass('b-h__menu_opened')) {
      $('.b-h__menu').addClass('b-h__menu_hide');
      $(this).removeClass('b-burger_active');
      setTimeout(() => {
        $('.b-h__menu').removeClass('b-h__menu_hide');
        $('.b-h__menu').removeClass('b-h__menu_opened');
        $('body').removeClass('_overflow');
        $('.b-h').css({'z-index': '15'}).removeClass('b-h_opened');
      }, 250);
      return;
    }
    $(this).toggleClass('b-burger_active');
    $('.b-h__menu').toggleClass('b-h__menu_opened');
    $('body').toggleClass('_overflow');
    $('.b-h').css({'z-index': '15'}).toggleClass('b-h_opened');
  });

  $('.overlay').on('click', function () {
    console.log('popal');
    if ($('.b-h__menu').hasClass('b-h__menu_opened')) {
      closeHeaderMenu();
    }
  });

  $('.b-menu__link').on('click', function (event) {
    if (event.currentTarget == event.target) {
      closeHeaderMenu();
    }
  });
});

// раскрытие разделов мобильного меню
$(function () {
  $('.b-menu__icon').on('click', function (event) {
    event.preventDefault();

    var $li = $(this).parent().parent();
    $li.toggleClass('b-menu__item_open');
    $li.find('.b-menu__submenu').slideToggle('fast');

    $li
      .siblings('.b-menu__item_open')
      .removeClass('b-menu__item_open')
      .find('.b-menu__submenu')
      .slideUp('fast');
  });
});

// открытие элемента программы по клику
$(function () {
  const toggleItem = function () {
    $(this).siblings().removeClass('b-program__item_opened').find('.b-program__descr').slideUp(300);
    $(this).toggleClass('b-program__item_opened');
    $(this).find('.b-program__descr').slideToggle(300);
  };
  $('.b-program__item_parent').on('click', toggleItem);

  // раскрывает первый элемент, если у него есть описание
  const firstItem = $('.b-program__item_parent').get(0);
  if (!!firstItem && firstItem.parentElement.dataset.shouldOpenFirstItem) {
    const hasDescr = !!firstItem.querySelector('.b-program__descr');
    if (hasDescr) {
      toggleItem.call(firstItem);
    }
  }

  $(document).click(function (e) {
    let div = $('.b-program__item_opened');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
      div.removeClass('b-program__item_opened');
      div.find('.b-program__descr').slideUp(300);
    }
  });
});

// инициализация анимации блоков
$(function () {
  AOS.init({
    duration: 1200,
    once: true,
  });
});

// кнопка скролла
$(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 1500) {
      $('.b-container__btn_scroll').fadeIn();
    } else {
      $('.b-container__btn_scroll').fadeOut();
    }
  });

  $('.b-container__btn_scroll').click(function () {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      600,
    );
    return false;
  });
});

// скролл до блока для остановки анимации на главной
// $(window).scroll(function() {
// 	$('.animated').each(function(){
// 		var imagePos = $(this).offset().top;
// 		var topOfWindow = $(window).scrollTop();
// 		if (imagePos < topOfWindow+50) {
// $(this).removeClass('animated');
// 		}
// 	});
// });

// подсказки
$(function () {
  function showTooltip(tooltipContent, popperInstance) {
    tooltipContent.setAttribute('data-show', '');

    popperInstance.setOptions(function (options) {
      options.modifiers.push({name: 'eventListeners', enabled: true});
      return options;
    });

    popperInstance.update();
  }

  function hideTooltip(tooltipContent, popperInstance) {
    tooltipContent.removeAttribute('data-show');

    popperInstance.setOptions(function (options) {
      options.modifiers.push({name: 'eventListeners', enabled: false});
      return options;
    });
  }

  function isVisibleTooltip(tooltipContent) {
    return tooltipContent.hasAttribute('data-show');
  }

  let tooltipBtns = document.querySelectorAll('.tooltip-btn');
  tooltipBtns.forEach(function (tooltipBtn) {
    let tooltipContent = tooltipBtn.parentNode.querySelector('.tooltip-content');

    let popperInstance = Popper.createPopper(tooltipBtn, tooltipContent, {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    });

    tooltipBtn.addEventListener('click', function () {
      if (!isVisibleTooltip(tooltipContent)) {
        showTooltip(tooltipContent, popperInstance);
      } else {
        hideTooltip(tooltipContent, popperInstance);
      }
    });
  });
});

function downloadFile(fileUrl, fileName, e) {
  var event = e ? e : window.event;
  if (event.stopPropagation) {
    event.stopPropagation();
  }

  if (event.cancelBubble != null) {
    event.cancelBubble = true;
  }

  var link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', fileName);
  link.click();

  return false;
}

// слайдер с годами
$(function () {
  window.yearPointsSwiper = [];
  $('.b-points').each(function() {
    let swiperType = 'years';
    let swiperSelector = '.b-points_years';
    if ($(this).hasClass('b-points_dates')) {
      swiperSelector = '.b-points_dates';
    } else {
      $(this).addClass('b-points_years');
      swiperType = 'years';
    }
    window.yearPointsSwiper[swiperType] = new Swiper(swiperSelector + ' .swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 'auto',
          spaceBetween: 16,
        },
        769: {
          slidesPerView: 3,
        },
      },
      scrollbar: {
        el: swiperSelector + ' .swiper-scrollbar',
      },
      pagination: {
        el: swiperSelector + ' .swiper-pagination',
      },
      navigation: {
        nextEl: swiperSelector + ' .swiper-button-next',
        prevEl: swiperSelector + ' .swiper-button-prev',
      },
    });
    if (typeof curSlide !== 'undefined' && !!curSlide && swiperType === 'years') {
      window.yearPointsSwiper[swiperType].slideTo(curSlide, 200, false);
    }
  });
});

$(function () {
  $('.b-menu__item_parent').on('mouseover', function () {
    $('.b-h').addClass('b-h_active');
  });
  $('.b-menu__item_parent').on('mouseout', function () {
    $('.b-h').removeClass('b-h_active');
  });
});